<header class="header">
  <ul class="list">
    <li class="item">
      <img class="icon" src="/assets/seeding.svg" alt="icon" />
      <a href="#">友站連結</a>
    </li>
    <li class="item">
      <img class="icon" src="/assets/seeding.svg" alt="icon" />
      <a href="#">聯絡我們</a>
    </li>
  </ul>
</header>
